/*
 * The GST a line carries, read off whichever way the rate was written down.
 *
 * CGST+SGST and IGST are two spellings of one tax, never two taxes: within a
 * state the levy is split between the centre and the state, across state
 * lines it is charged whole as IGST. A medicine - and the batch seeded from
 * it - carries both spellings at once, because the medicine form writes
 * `igst` as the pair's own sum when it reads a rate off an HSN code. Adding
 * all three together therefore charges the purchase about twice over: a 5%
 * medicine billed at 10%.
 *
 * The pair is believed wherever it is given, which is the same way the
 * medicine form resolves an HSN code's rates; IGST is the rate only where no
 * pair was given at all.
 */
export const gstPercent = (rates) => {
  const sgst = Number(rates?.sgst) || 0;
  const cgst = Number(rates?.cgst) || 0;
  const igst = Number(rates?.igst) || 0;
  return sgst || cgst ? sgst + cgst : igst;
};

/**
 * The same rate, split the way it was given, so the heads a summary prints
 * add up to the total it prints beside them. Only one spelling is ever
 * returned with figures in it - the other reads zero.
 */
export const gstSplit = (rates) => {
  const sgst = Number(rates?.sgst) || 0;
  const cgst = Number(rates?.cgst) || 0;
  const igst = Number(rates?.igst) || 0;
  return sgst || cgst
    ? { sgst, cgst, igst: 0 }
    : { sgst: 0, cgst: 0, igst };
};

/*
 * Cess is a levy of its own standing beside GST, not a slab of it. It is
 * charged on the same taxable value and is owed all the same, so it is
 * counted into what a line comes to - but counted under its own name, which
 * is what the GST summary and the bill disagreed about when it was quietly
 * folded into the GST percentage.
 */
export const cessPercent = (rates) => Number(rates?.cess) || 0;
